export default "__VITE_ASSET__CUJBgPGB__"